let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c8vYo")).then(() => parcelRequire('i3nvV'));